import { AbstractModel, isNullOrUndefined, DateUtil } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { ScreeningPackage } from './screening-package';
import { ScreeningReason } from './screening-reason';
import { ScreeningResult } from './screening-result';
import { ScreeningStatus } from './screening-status';

@inheritSerialization(AbstractModel)
export class Screening extends AbstractModel {
  @autoserialize
  driverId: number;

  @autoserialize
  sterlingScreeningIdentifier: string;

  @autoserializeAs(ScreeningPackage)
  screeningPackage: ScreeningPackage;

  @autoserializeAs(ScreeningStatus)
  screeningStatus: ScreeningStatus;

  @autoserializeAs(ScreeningResult)
  screeningResult: ScreeningResult;

  @autoserializeAs(ScreeningReason)
  screeningReason: ScreeningReason;

  @autoserializeAs(Date)
  submittedDate: Date;

  @autoserializeAs(Date)
  completedDate: Date;

  @autoserialize
  filename: string;

  @autoserialize
  statusDisplay: string;

  @autoserialize
  active: boolean;

  /**** Serialization ****/

  static OnSerialized(instance: Screening, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.submittedDate)) {
      json.submittedDate = DateUtil.serializeDate(instance.submittedDate);
    }
    if (!isNullOrUndefined(instance.completedDate)) {
      json.completedDate = DateUtil.serializeDate(instance.completedDate);
    }
  }

  static OnDeserialized(instance: Screening, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['submittedDate'])) {
      instance.submittedDate = DateUtil.deserializeDate(json['submittedDate']);
    }

    if (!isNullOrUndefined(json['completedDate'])) {
      instance.completedDate = DateUtil.deserializeDate(json['completedDate']);
    }
  }
}
